import { useState } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  Button,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useAuthContext } from 'src/auth/hooks';
import useScenarioService from 'src/services/scenario-service';

export default function AddScenarioDialog({ open, onClose, editData }) {
  const { user } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const { createScenario, updateScenario } = useScenarioService(user?.id);

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      PaperProps={{
        component: 'form',
        onSubmit: async (event) => {
          setLoading(true);
          event.preventDefault();

          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries(formData.entries());

          const { name } = formJson;

          let result;
          if (editData) result = await updateScenario(editData?.id ?? 'default', { name });
          else result = await createScenario({ name });

          setLoading(false);
          onClose(result);
        },
      }}
    >
      <DialogTitle>{editData ? 'Edit' : 'Add'} Scenario</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {editData ? 'Edit' : 'Create a new'} scenario to visualize how different circumstances
          impacts your finances.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          name="name"
          label="Scenario Name"
          type="text"
          fullWidth
          defaultValue={editData?.name}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Cancel</Button>
        <LoadingButton loading={loading} type="submit" variant="contained" color="primary">
          {editData ? 'Update' : 'Create'}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
